import React from "react";

export const MagicLoadingCard = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <div className="w-full h-full pt-6 px-6 pb-4 flex flex-col gap-8 rounded-2xl bg-cover bg-center bg-no-repeat relative overflow-hidden items-center justify-center text-sm text-center text-gray-6">
      <style>
        {`
          @keyframes gradientShift {
            0% {
              background-position: 0% 50%;
            }
            100% {
              background-position: 100% 50%;
            }
          }
        `}
      </style>
      <div
        className="absolute inset-0 rounded-2xl"
        style={{
          background:
            "linear-gradient(90deg, rgba(57,220,234,0.05) 10%, rgba(255,40,166,0.05) 88%)",
          backgroundSize: "200% 100%",
          animation: "gradientShift 3s ease-in-out infinite alternate",
        }}
      />
      {children}
    </div>
  );
};
